import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "employee-offer-letters"
    }}>{`Employee Offer Letters`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Employee offer letters are one of the first experiences new hires have with an organization, so these documents should be on-brand, professional, and uniform. However, creating documents in Microsoft Word from scratch wastes valuable resources and results in inconsistent experiences. Adobe Acrobat Services helps streamline the process of generating and delivering offer letters in a variety of ways, letting you:`}</p>
    <ul>
      <li parentName="ul">{`Create templates in Word and generate PDFs based on a simple data set using the Adobe Document Generation API`}</li>
      <li parentName="ul">{`Merge data and HTML templates into a PDF letter using the Adobe PDF Services API`}</li>
      <li parentName="ul">{`Route offer letters to candidates and hiring managers, track consumption in real-time, verify user identities, and capture electronic signatures by leveraging `}<a parentName="li" {...{
          "href": "https://acrobat.adobe.com/us/en/sign.html"
        }}>{`Adobe Acrobat Sign`}</a></li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.io/apis/documentcloud/sign.html"
        }}>{`Adobe Acrobat Sign API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`An organization needs to ramp up seasonal hiring of employees across multiple locations. Candidates use an online application that captures their information. Later, this data is used to populate an offer letter that includes the ability to sign the document electronically.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Build a JSON-based data model of values to be incorporated into the offer letter documents`}</li>
      <li parentName="ol">{`Create an offer letter template using Word or HTML`}</li>
      <li parentName="ol">{`Use Adobe Document Generation Tagger in the `}<a parentName="li" {...{
          "href": "https://appsource.microsoft.com/en-us/product/office/WA104380526?tab=Overview"
        }}>{`Microsoft Word Add-in`}</a>{` to tag text fields in the template based on the data model`}</li>
      <li parentName="ol">{`Generate the offer letter PDF using Adobe Document Generation API`}</li>
      <li parentName="ol">{`Upload the document to Adobe Acrobat Sign and send Offer Letter as an agreement using `}<a parentName="li" {...{
          "href": "https://acrobat.adobe.com/us/en/sign.html"
        }}>{`Adobe Acrobat Sign`}</a>{` or `}<a parentName="li" {...{
          "href": "https://www.adobe.io/apis/documentcloud/sign/docs.html"
        }}>{`Adobe Acrobat Sign API`}</a></li>
    </ol>
    <h3 {...{
      "id": "building-in-power-automate"
    }}>{`Building in Power Automate`}</h3>
    <p>{`A solution to this use-case can also be implemented in Power Automate by using the following Adobe connectors:`}</p>
    <ul>
      <li parentName="ul">{`Adobe PDF Services Connector (includes Document Generation)`}</li>
      <li parentName="ul">{`Adobe Acrobat Sign Connector`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      